<template>
  <div id="wrapper">
    <Nav :message="message" />
    <ProfileList :status="0" />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import ProfileList from '@/components/profile/ProfileList.vue'

export default {
  name: 'staff-list',
  props: ['message'],
  components: {
    Nav,
    ProfileList
  }
}
</script>